import React from 'react';
import _ from 'lodash';
import { TextField, MenuItem } from '@mui/material';

export const SmallFormTextField = props => {
  const { placeholder, multiline, rows, name, value, id, onChange, error, helperText, select, options, sx, multiple, disabled, label, type, readOnly, renderValue } = props;

  return (
    <TextField
      disabled={disabled || false}
      select={select}
      onChange={onChange}
      error={error}
      helperText={helperText}
      id={id}
      name={name}
      value={value}
      size="small"
      placeholder={placeholder}
      multiline={multiline}
      rows={rows}
      type={type}
      sx={{ width: '60%', ...sx, maxWidth: '1200px' }}
      label={label}
      InputProps={{
        readOnly
      }}
      SelectProps={{
        multiple,
        value,
        MenuProps: {
          style: { zIndex: 35001 }
        },
        renderValue
      }}
    >
      {!_.isNil(options) && options.length > 0
        ? options.map(option => (
          <MenuItem key={option.value} value={option.value} disabled={option?.disabled}>
            {option.label}
          </MenuItem>
        ))
        : (
          <MenuItem disabled>Brak dostępnych opcji</MenuItem>
        )
      }
    </TextField>
  );
};
